/* WL BRAND RAIL — one control, two homes
   ============================================================================
   WHERE THIS LIVES, AND WHY IT MOVED.
   The first version put a brand rail across the top of the chart. Ryan killed
   it: "where you're suggesting will take away from the flight chart
   experience." He was right. The chart's job is to draw flight paths, and a
   row of 142 brand names above it turns the first thing you see into a
   filing cabinet. So the rail lives where a brand question is actually being
   asked -- inside the picker while you build a bag, and beside the shot-shape
   map where "show me only Innova" is a real question -- and nowhere else.

   THE RANKING IS PURE MOULD COUNT. Ryan chose this over stock, sales or a
   curated order, and the reason is that this app is licensed to other people.
   Mould count is the one ranking that means the same thing for a retailer, a
   manufacturer and a distributor, so it does not have to be re-decided per
   tenant. Innova first because Innova makes the most moulds, not because
   anyone paid for the slot.

   TOP TEN, THEN SEARCH. Ryan: "after a certain cutoff I want people to be
   able to search for their brand rather than us to populate everything." Ten
   chips covers the brands most people came for; everyone else types. The
   search ranks by "highest probability" -- a prefix match beats a match in
   the middle of the name, and mould count breaks the tie, so typing "d"
   offers Discraft before Doomsday Discs.

   NO ENGINE COUPLING. This module never reaches into the 50 KB chart engine.
   It publishes window.__FDS_BRANDS__ and calls whatever onPick it was handed;
   the picker filters its own list, the map filters its own pool, and if the
   engine's own #fdsBrand select is the target, the caller drives that select
   through a real change event exactly as a person would.
   ========================================================================= */
(function () {
"use strict";
var FD = window.__FDS__; if (!FD || !FD.molds) return;

var TOP_N = 10;

/* [{ v: brand, n: moulds }], most moulds first, name as the tiebreak so the
   order is stable between builds. */
var RANK = (function () {
  var n = {};
  FD.molds.forEach(function (d) { n[d.v] = (n[d.v] || 0) + 1; });
  return Object.keys(n).map(function (v) { return { v: v, n: n[v] }; })
    .sort(function (a, b) { return b.n - a.n || a.v.localeCompare(b.v); });
})();

var BY_NAME = {}; RANK.forEach(function (r) { BY_NAME[r.v.toLowerCase()] = r; });

function esc(s) {
  return String(s).replace(/[&<>"]/g, function (c) {
    return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
  });
}

/* Highest probability first. Three tiers, and the tiers matter more than the
   sort inside them: a brand you have started typing the name of beats one
   that merely contains those letters, however many moulds it makes. */
function search(q, limit) {
  q = (q || "").trim().toLowerCase();
  if (!q) return RANK.slice(0, limit || TOP_N);
  var pre = [], word = [], mid = [];
  RANK.forEach(function (r) {
    var l = r.v.toLowerCase(), i = l.indexOf(q);
    if (i < 0) return;
    if (i === 0) pre.push(r);
    else if (l.charAt(i - 1) === " " || l.charAt(i - 1) === "(") word.push(r);
    else mid.push(r);
  });
  return pre.concat(word, mid).slice(0, limit || 12);
}

/* ---------------------------------------------------------------- mounting
   opts:
     value    currently selected brand ("" = all)
     extra    [{ v, lbl, n }] chips pinned before the brands. The picker uses
              this for "Suggested for you", which is not a brand but sits in
              the same row and behaves the same way.
     onPick   fn(brandOrExtraValue)
     allLabel text for the reset chip
*/
function mount(host, opts) {
  if (!host) return null;
  opts = opts || {};
  var value = opts.value || "";
  var extra = opts.extra || [];
  var showAll = false;
  var q = "";

  /* The search box is a sibling of the chips INSIDE the same wrapping flex,
     not a column beside it. As its own column it got pushed onto a line of its
     own the moment the chips wrapped, and an input floating under a row of
     buttons reads as a separate control rather than the tail of the row. */
  host.classList.add("fdsfc-br");
  host.innerHTML =
    '<div class="fdsfc-br__chips" role="group" aria-label="Filter by brand"></div>' +
    '<div class="fdsfc-br__more"></div>';

  var chips = host.querySelector(".fdsfc-br__chips");
  var more = host.querySelector(".fdsfc-br__more");
  var input = document.createElement("input");
  input.type = "search";
  input.className = "fdsfc-br__q";
  input.autocomplete = "off";
  input.placeholder = "Other brand…";
  input.setAttribute("aria-label", "Search brands");

  function chip(v, lbl, n) {
    return '<button type="button" class="fdsfc-br__chip" data-v="' + esc(v) + '"' +
      (v === value ? " data-on" : "") + ' aria-pressed="' + (v === value) + '">' +
      esc(lbl) + (n ? '<span class="fdsfc-br__n">' + n + "</span>" : "") + "</button>";
  }

  function draw() {
    var list = q ? search(q, 12) : RANK.slice(0, showAll ? RANK.length : TOP_N);

    /* A brand chosen from the search box stays visible after the box is
       cleared. Otherwise picking "Kastaplast" and then clearing the search
       makes the active filter vanish from the rail while it is still on. */
    if (value && !q && !showAll && !list.some(function (r) { return r.v === value; }) &&
        !extra.some(function (e) { return e.v === value; })) {
      var hit = BY_NAME[value.toLowerCase()];
      if (hit) list = list.slice(0, TOP_N - 1).concat([hit]);
    }

    /* Rebuilding innerHTML would blow away the live input -- and with it the
       caret -- on every keystroke, so the input is re-appended rather than
       re-created. */
    chips.innerHTML =
      extra.map(function (e) { return chip(e.v, e.lbl, e.n); }).join("") +
      chip("", opts.allLabel || "All brands", 0) +
      list.map(function (r) { return chip(r.v, r.v, r.n); }).join("");
    chips.appendChild(input);

    if (q) {
      more.innerHTML = list.length ? "" :
        '<span class="fdsfc-br__none">No brand matches “' + esc(q) + '”.</span>';
    } else {
      more.innerHTML = RANK.length > TOP_N
        ? '<button type="button" class="fdsfc-br__all">' +
            (showAll ? "Show the top " + TOP_N : "Show all " + RANK.length + " brands") +
          "</button>"
        : "";
    }
    if (opts.note) more.appendChild(opts.note);
  }

  host.addEventListener("click", function (e) {
    var c = e.target.closest(".fdsfc-br__chip");
    if (c) {
      value = c.getAttribute("data-v");
      draw();
      if (opts.onPick) opts.onPick(value);
      return;
    }
    if (e.target.closest(".fdsfc-br__all")) { showAll = !showAll; draw(); }
  });

  input.addEventListener("input", function (e) { q = e.target.value; draw(); });

  /* Enter on a search with exactly one plausible answer picks it. Typing
     "kasta" and pressing enter should not require finding the chip. */
  input.addEventListener("keydown", function (e) {
    if (e.key !== "Enter") return;
    e.preventDefault();
    var hits = search(q, 12);
    if (!hits.length) return;
    value = hits[0].v;
    draw();
    if (opts.onPick) opts.onPick(value);
  });

  draw();

  return {
    value: function () { return value; },
    set: function (v) { value = v || ""; draw(); },
    clear: function () { value = ""; q = ""; input.value = ""; draw(); }
  };
}

window.__FDS_BRANDS__ = { rank: RANK, search: search, mount: mount, topN: TOP_N };
})();